import { Link } from "react-router-dom";

const SEV = {
  high: { color: "#dc2626", bg: "#fef2f2", border: "#fecaca", label: "Critico", emoji: "🔴" },
  medium: { color: "#eab308", bg: "#fefce8", border: "#fef08a", label: "Attenzione", emoji: "🟡" },
  low: { color: "#0a1420", bg: "#f5f7fb", border: "#e5e7eb", label: "Info", emoji: "🔵" },
};

const TYPE_LABEL = {
  delay_predicted: "Ritardo previsto",
  posa_behind: "Posa indietro",
  overdue: "Consegna scaduta",
  margin_low: "Margine basso",
  phase_stalled: "Cantiere fermo",
};

/**
 * Reusable alerts list.
 * - `alerts`: array of alert dicts from the backend
 * - `variant="compact"` uses tighter spacing (for dashboard column); "full" gives more room
 * - `linkToCantiere` toggles the "Vai al cantiere" affordance
 */
export default function AlertsPanel({ alerts = [], variant = "full", linkToCantiere = true, emptyLabel = "Nessun alert attivo" }) {
  if (!alerts.length) {
    return (
      <div className="p-6 text-center" data-testid="gest-alerts-empty">
        <div className="text-[28px] mb-2">✓</div>
        <div className="text-[13px] text-[#6e6e73]">{emptyLabel}</div>
      </div>
    );
  }
  const compact = variant === "compact";
  return (
    <div className={compact ? "divide-y divide-black/5" : "space-y-2.5"} data-testid="gest-alerts-list">
      {alerts.map((a, i) => {
        const sev = SEV[a.severity] || SEV.low;
        const key = `${a.cantiere_id}-${a.type}-${i}`;
        const inner = (
          <div className={compact ? "px-4 py-3 flex items-start gap-3 hover:bg-[#f5f7fb] transition-colors" : `flex items-start gap-3 p-4 rounded-xl border`} style={compact ? {} : { backgroundColor: sev.bg, borderColor: sev.border }}>
            <div className="text-[16px] shrink-0" aria-hidden="true">{sev.emoji}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className={compact ? "text-[13px] font-medium text-[#0a1420] truncate" : "text-[13.5px] font-semibold text-[#0a1420]"}>{a.title}</span>
                {!compact && (
                  <span className="text-[10px] uppercase tracking-widest px-1.5 py-0.5 rounded" style={{ color: sev.color, backgroundColor: "#ffffff" }}>{TYPE_LABEL[a.type] || a.type}</span>
                )}
              </div>
              {compact ? (
                <div className="text-[11.5px] text-[#6e6e73] truncate mt-0.5">
                  <span className="text-[#0a1420]">{a.cantiere_nome}</span> · {a.message}
                </div>
              ) : (
                <>
                  <div className="text-[12.5px] text-[#0a1420]/80 mt-1 leading-relaxed">{a.message}</div>
                  {a.action && (
                    <div className="text-[11.5px] mt-1.5 flex items-center gap-1.5 text-[#0a1420]/70">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
                      <span>{a.action}</span>
                    </div>
                  )}
                </>
              )}
            </div>
            {compact && a.cantiere_nome && (
              <span className="text-[11px] text-[#6e6e73] shrink-0 hidden md:block">{TYPE_LABEL[a.type] || a.type}</span>
            )}
          </div>
        );
        return linkToCantiere && a.cantiere_id ? (
          <Link key={key} to={`/gestione/cantieri/${a.cantiere_id}`} data-testid={`gest-alert-${a.type}`} className="block no-underline">
            {inner}
          </Link>
        ) : (
          <div key={key} data-testid={`gest-alert-${a.type}`}>{inner}</div>
        );
      })}
    </div>
  );
}
